// plugins/axios-plugin.js
import axios from 'axios'

const backgroundEndpoint = ['/api/basket-session', '/api/report']

export default function(router) {
    // Apply response interceptor to the global axios instance
    axios.interceptors.response.use(
        response => {
            return response;
        },
        error => {
            const code = parseInt(error.response && error.response.status);
            if (code === 401 && router.currentRoute.value.path !== '/login') {
                router.push('/login');
            }
            return Promise.reject(error);
        }
    );

    // Apply request interceptor to the global axios instance
    axios.interceptors.request.use(config => {
        if (
            backgroundEndpoint.includes(config.url) ||
            (config.params && config.params.filteredCatalogue)
        ) {
            config.progress = false;
        }
        return config;
    });
}
